class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    initializeTopferoPriceRanges(this);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    initializeTopferoPriceRanges();
    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const currentActiveFacetsElement = document.querySelector(selector);
      if (!currentActiveFacetsElement) return;
      currentActiveFacetsElement.outerHTML = activeFacetsElement.outerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.tf-filter-drawer__title',
      '.tf-filter-drawer__apply-count',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    initializeTopferoPriceRanges();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const sourceForm = event.target.closest('form');
      const isMobile = sourceForm.id === 'FacetFiltersFormMobile' || sourceForm.id === 'FacetSortMobileForm';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === sourceForm.id ||
            form.id === 'FacetFiltersForm' ||
            form.id === 'FacetSortDrawerForm'
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortMobileForm') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

if (!customElements.get('sort-disclosure')) {
  customElements.define(
    'sort-disclosure',
    class SortDisclosure extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[name="sort_by"]');
        this.button = this.querySelector('button');
        this.panel = this.querySelector('.disclosure__list-wrapper');
        this.overlay = this.querySelector('.tf-sort-disclosure__overlay');
        this.links = this.querySelectorAll('a[data-value]');
        this.boundDocumentClick = this.onDocumentClick.bind(this);
        this.panelParent = null;
        this.panelNextSibling = null;
        this.overlayParent = null;
        this.overlayNextSibling = null;

        this.button?.addEventListener('click', this.toggle.bind(this));
        this.links.forEach((link) => link.addEventListener('click', this.onItemClick.bind(this)));
        this.addEventListener('keydown', this.onKeyDown.bind(this));
        document.addEventListener('click', this.boundDocumentClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.boundDocumentClick);
        this.restoreMobileLayer();
      }

      toggle(event) {
        event.preventDefault();
        const expanded = this.button.getAttribute('aria-expanded') === 'true';
        expanded ? this.close() : this.open();
      }

      open() {
        this.button.setAttribute('aria-expanded', 'true');
        this.classList.add('open');
        this.portalMobileLayer();
        this.panel.removeAttribute('hidden');
        this.overlay?.removeAttribute('hidden');
        if (window.matchMedia('(max-width: 749px)').matches) {
          document.body.classList.add('overflow-hidden-mobile', 'tf-sort-disclosure-open');
        }
      }

      close() {
        this.button.setAttribute('aria-expanded', 'false');
        this.classList.remove('open');
        this.panel.setAttribute('hidden', true);
        this.overlay?.setAttribute('hidden', true);
        document.body.classList.remove('overflow-hidden-mobile', 'tf-sort-disclosure-open');
        this.restoreMobileLayer();
      }

      portalMobileLayer() {
        if (!window.matchMedia('(max-width: 749px)').matches || !this.panel || !this.overlay) return;

        if (!this.panelParent) {
          this.panelParent = this.panel.parentNode;
          this.panelNextSibling = this.panel.nextSibling;
        }

        if (!this.overlayParent) {
          this.overlayParent = this.overlay.parentNode;
          this.overlayNextSibling = this.overlay.nextSibling;
        }

        document.body.append(this.overlay, this.panel);
      }

      restoreMobileLayer() {
        if (this.overlayParent && this.overlay && this.overlay.parentNode !== this.overlayParent) {
          this.overlayParent.insertBefore(this.overlay, this.overlayNextSibling);
        }

        if (this.panelParent && this.panel && this.panel.parentNode !== this.panelParent) {
          this.panelParent.insertBefore(this.panel, this.panelNextSibling);
        }
      }

      onDocumentClick(event) {
        const clickedPanel = this.panel?.contains(event.target);
        const clickedOverlay = this.overlay?.contains(event.target);

        if (clickedOverlay || event.target === this || (!this.contains(event.target) && !clickedPanel)) {
          this.close();
        }
      }

      onKeyDown(event) {
        if (event.key === 'Escape') {
          this.close();
          this.button.focus();
        }
      }

      updateSelectedItem(selectedLink) {
        const selectedLabel = selectedLink.querySelector('span:last-child')?.textContent?.trim();
        const currentValue = this.querySelector('.tf-sort-disclosure__value');

        if (currentValue && selectedLabel) {
          currentValue.textContent = selectedLabel;
          currentValue.setAttribute('title', selectedLabel);
        }

        this.links.forEach((link) => {
          const check = link.querySelector('.tf-sort-disclosure__check');

          link.toggleAttribute('aria-current', link === selectedLink);
          if (check) {
            check.innerHTML =
              link === selectedLink
                ? '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-width="2" d="M20 6 9 17l-5-5"/></svg>'
                : '';
          }
        });
      }

      onItemClick(event) {
        event.preventDefault();
        const value = event.currentTarget.dataset.value;
        if (!this.input || !value || this.input.value === value) {
          this.close();
          return;
        }

        this.input.value = value;
        this.updateSelectedItem(event.currentTarget);
        this.close();

        const facetFiltersForm = this.input.closest('facet-filters-form');
        if (facetFiltersForm && typeof facetFiltersForm.onSubmitHandler === 'function') {
          facetFiltersForm.onSubmitHandler({
            preventDefault: () => {},
            target: this.input,
            srcElement: this.input,
          });
          return;
        }

        this.input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  );
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

function initializeTopferoPriceRanges(root = document) {
  root.querySelectorAll('[data-tf-price-range]').forEach((range) => {
    if (range.dataset.tfPriceRangeReady === 'true') return;
    range.dataset.tfPriceRangeReady = 'true';

    const minRange = range.querySelector('.range-input--min');
    const maxRange = range.querySelector('.range-input--max');
    const minInput = document.getElementById(range.dataset.minInput);
    const maxInput = document.getElementById(range.dataset.maxInput);
    const fill = range.querySelector('.range-fill');
    const container = range.closest('.tf-price-range');
    const minLabel = container?.querySelector('[data-tf-price-min-label]');
    const maxLabel = container?.querySelector('[data-tf-price-max-label]');

    if (!minRange || !maxRange || !minInput || !maxInput || !fill) return;

    const parseValue = (value, fallback = 0) => {
      const parsed = Number(String(value || '').replace(',', '.').replace(/\s/g, ''));
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const max = parseValue(maxRange.max, 0);
    const formatMoney = (value) => {
      const activeCurrency = Shopify?.currency?.active || 'EUR';
      const formatted = new Intl.NumberFormat(document.documentElement.lang || 'sk-SK', {
        style: 'currency',
        currency: activeCurrency,
      }).format(Math.round(value));

      if (activeCurrency === 'EUR') {
        return `${formatted.replace(/EUR/g, '').replace(/€/g, '').trim()} €`;
      }

      return formatted;
    };
    const setTextValue = (input, value) => {
      input.value = String(Math.round(value));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    const updateFill = () => {
      const minValue = parseValue(minRange.value, 0);
      const maxValue = parseValue(maxRange.value, max);
      const minPercent = max > 0 ? (minValue / max) * 100 : 0;
      const maxPercent = max > 0 ? (maxValue / max) * 100 : 100;

      range.style.setProperty('--tf-range-min', `${Math.min(minPercent, maxPercent)}%`);
      range.style.setProperty('--tf-range-max', `${Math.max(minPercent, maxPercent)}%`);
      if (minLabel) minLabel.textContent = formatMoney(minValue);
      if (maxLabel) maxLabel.textContent = formatMoney(maxValue);
    };

    const syncFromRange = (changedRange) => {
      let minValue = parseValue(minRange.value, 0);
      let maxValue = parseValue(maxRange.value, max);

      if (minValue > maxValue) {
        if (changedRange === minRange) {
          maxValue = minValue;
          maxRange.value = String(maxValue);
        } else {
          minValue = maxValue;
          minRange.value = String(minValue);
        }
      }

      setTextValue(minInput, minValue);
      setTextValue(maxInput, maxValue);
      updateFill();
    };

    const syncFromText = () => {
      const minValue = parseValue(minInput.value, 0);
      const maxValue = parseValue(maxInput.value, max);

      minRange.value = String(Math.min(Math.max(minValue, 0), max));
      maxRange.value = String(Math.min(Math.max(maxValue, 0), max));
      updateFill();
    };

    minRange.addEventListener('input', () => syncFromRange(minRange));
    maxRange.addEventListener('input', () => syncFromRange(maxRange));
    minInput.addEventListener('input', syncFromText);
    maxInput.addEventListener('input', syncFromText);
    updateFill();
  });
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function closeSortDisclosures() {
  document.querySelectorAll('sort-disclosure').forEach((sortDisclosure) => {
    if (typeof sortDisclosure.close === 'function') {
      sortDisclosure.close();
      return;
    }

    sortDisclosure.querySelector('button')?.setAttribute('aria-expanded', 'false');
    sortDisclosure.querySelector('.disclosure__list-wrapper')?.setAttribute('hidden', true);
  });
}

function syncTopferoFilterDrawer(disclosure) {
  const drawer = disclosure?.querySelector('#FacetFiltersFormMobile.mobile-facets.tf-slide-drawer');
  if (!drawer) return;

  drawer.classList.toggle('active', disclosure.open && disclosure.classList.contains('menu-opening'));
}

function closeTopferoFilterDrawer(disclosure) {
  const summary = disclosure?.querySelector(':scope > summary');
  if (!summary || !disclosure.open) return;

  disclosure
    .querySelector('#FacetFiltersFormMobile.mobile-facets.tf-slide-drawer')
    ?.classList.remove('active');

  const menuDrawer = disclosure.closest('menu-drawer');
  if (menuDrawer && typeof menuDrawer.closeMenuDrawer === 'function') {
    menuDrawer.closeMenuDrawer(new Event('click'), summary);
    return;
  }

  disclosure.classList.remove('menu-opening');
  disclosure.querySelectorAll('details').forEach((details) => {
    details.removeAttribute('open');
    details.classList.remove('menu-opening');
  });
  disclosure.removeAttribute('open');
  summary.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
  syncTopferoFilterDrawer(disclosure);
}

document.addEventListener(
  'toggle',
  (event) => {
    const disclosure = event.target.closest?.('details.mobile-facets__disclosure');
    if (!disclosure) return;

    syncTopferoFilterDrawer(disclosure);
  },
  true
);

document.querySelectorAll('details.mobile-facets__disclosure').forEach(syncTopferoFilterDrawer);

document.addEventListener(
  'click',
  (event) => {
    const drawerCloseTarget = event.target.closest('.tf-filter-drawer__overlay, .tf-filter-drawer__close');
    if (drawerCloseTarget) {
      event.preventDefault();
      closeTopferoFilterDrawer(drawerCloseTarget.closest('details.mobile-facets__disclosure'));
      return;
    }

    if (event.target.matches('#FacetFiltersFormMobile.mobile-facets.tf-slide-drawer')) {
      event.preventDefault();
      closeTopferoFilterDrawer(event.target.closest('details.mobile-facets__disclosure'));
      return;
    }

    const applyButton = event.target.closest('.mobile-facets__apply');
    if (!applyButton) return;

    closeTopferoFilterDrawer(applyButton.closest('details.mobile-facets__disclosure'));
  },
  true
);

initializeTopferoPriceRanges();

